export const appHeaderSelector = '[data-testid="app-header"]';
export const appFooterSelector = '[data-testid="footer"]';
export const mainLayoutSelector = '[data-testid="main-layout"]';
